import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import { Observable } from 'rxjs';

const noop = () => {
};

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-employee-multiselect',
  templateUrl: './EmployeeMultiSelect.component.html'
})
export class EmployeeMultiSelectComponent implements OnInit {

    //The internal data model
    private innerValue: any = '';
    
    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.valueChange.emit(v);
            this.onChangeCallback(v);
        }
    }

    //Set touched on blur
    onBlur() {
        this.onTouchedCallback();
    }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    @Input() public selectedIDs: number[] = [];
    @Output() public valueChange: EventEmitter<number> = new EventEmitter();
    IDsToSelectOnLoad: number[] = [];
    
    selectItems: SelectItem[] = [];
    employees: ent.Employee[] = [];

    constructor(private employeeService: serv.EmployeeService) 
    { 
    }


    ngOnInit(): void {
        //this.load();
    }

    public load(): Observable<any>{

        return new Observable((observer) => { 
            
            this.employeeService.getEmployeesLite().subscribe(results => {
                results.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
                results.forEach(y=> this.employees.push(y));
                if (this.IDsToSelectOnLoad){
                    for (var id of this.IDsToSelectOnLoad){
                        this.selectedIDs.push(id);
                    }
                }
                observer.next(results);
                observer.complete();
            });

        });
    }
    
}